import { useTranslate } from "@similarweb/i18n-provider";
import { Text } from "@similarweb/ui-components/foundations";

import {
    EMPTY_IMG_HEIGHT,
    EMPTY_IMG_WIDTH,
    HOURGLASS_IMG_SRC,
} from "app/pages/activation/components/HomeWithData/Alerts/constants";
import {
    ALERTS_EMPTY_STATE_TEXT,
    ALERTS_EMPTY_STATE_TITLE,
} from "app/pages/activation/components/HomeWithData/Alerts/texts";
import { alertsDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";

import * as SC from "./styles";

export const EmptyState = () => {
    const { translate } = useTranslate();

    return (
        <SC.Container data-automation={alertsDataAutomation.emptyState}>
            <img
                src={HOURGLASS_IMG_SRC}
                alt="Empty State"
                width={EMPTY_IMG_WIDTH}
                height={EMPTY_IMG_HEIGHT}
                data-automation={alertsDataAutomation.emptyStateImg}
            />

            <SC.TextContainer data-automation={alertsDataAutomation.emptyStateText}>
                <Text fontVariant="h5">{translate(ALERTS_EMPTY_STATE_TITLE)}</Text>
                <Text fontVariant="body1">{translate(ALERTS_EMPTY_STATE_TEXT)}</Text>
            </SC.TextContainer>
        </SC.Container>
    );
};
